import { FC } from "react";
import { useFormContext } from "react-hook-form";

import { useCrudEditContext } from "@ryde/redux";
import {
  IExtendableDto,
  METADATA_KEY,
  RideProductionFields,
} from "@ryde/shared";

import { ProductionViewLogsButton } from "../../../rich-logs";

export const RideProductionExpand: FC = () => {
  const { watch } = useFormContext();
  const {
    data: { dto },
  } = useCrudEditContext<IExtendableDto>();
  const rideProductionId = watch(RideProductionFields.id);
  const rideProductionLogsOld = watch(RideProductionFields.logs);
  const rideProductionLogData = watch(RideProductionFields.logsData);
  const rideProductionMetadata = watch(METADATA_KEY);
  // logsCount column (active/completed produce), legacy fallback: logData.state only (pre-column rows)
  const rideProductionLogsCount =
    watch(RideProductionFields.logsCount) ??
    rideProductionLogData?.state?.logsCount ??
    dto?.logsCount;

  return (
    <ProductionViewLogsButton
      productionId={rideProductionId}
      logsCount={rideProductionLogsCount}
      logsFromWatchedApiOld={rideProductionLogsOld}
      productionFilters={rideProductionMetadata}
    />
  );
};
